'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CreationActionTypes = require('../actionTypes/CreationActionTypes');

var _CreationActionTypes2 = _interopRequireDefault(_CreationActionTypes);

var _Create = require('../selectors/Create');

var _AnalyticsActions = require('../actions/AnalyticsActions');

var _actionWithPayload = require('../utils/actionWithPayload');

var _actionWithPayload2 = _interopRequireDefault(_actionWithPayload);

var _AnalyticsActionTypes = require('../actionTypes/AnalyticsActionTypes');

var _AnalyticsActionTypes2 = _interopRequireDefault(_AnalyticsActionTypes);

var _trackPortalCreated = require('../tracking/trackPortalCreated');

var _trackPortalCreated2 = _interopRequireDefault(_trackPortalCreated);

var _AppConfigContainer = require('../globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

var _isFunnel = require('../utils/isFunnel');

var _isFunnel2 = _interopRequireDefault(_isFunnel);

var _PartnerActions = require('../actions/PartnerActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function hubFromPayload(payload) {
  return payload ? payload.createdHubId : null;
}

function userCreatedFromPayload(payload) {
  return payload ? payload.userCreated : null;
}

function userOnlyFromPayload(payload) {
  return payload ? payload.userOnly : null;
}

exports.default = _defineProperty({}, _CreationActionTypes2.default.CREATION_SUCCEEDED, function (action, state, dispatch) {
  var hubId = (0, _Create.getPortalIdToAuthenticate)(state) || hubFromPayload(action.payload);
  var createInfo = (0, _Create.getCreate)(state);
  var userCreated = createInfo.get('userCreated') || userCreatedFromPayload(action.payload);
  var userOnly = createInfo.get('userOnly') || userOnlyFromPayload(action.payload);

  //if it was also a brand new user
  if (userCreated) {
    dispatch((0, _actionWithPayload2.default)(_AnalyticsActionTypes2.default.ANALYTICS_USER_NEW));
  }

  if (!userOnly) {
    //track both
    dispatch((0, _actionWithPayload2.default)(_AnalyticsActionTypes2.default.ANALYTICS_PORTAL_NEW));
    dispatch((0, _AnalyticsActions.trackSignupCompleted)({ newUser: userCreated }));
    //attempt lead attribution for the Partner Link
    if (_isFunnel2.default.crm()) {
      dispatch((0, _PartnerActions.attributeLeadIfReferred)());
    }

    //support the old trackportal created, this might be not needed anymore
    if (hubId) {
      (0, _trackPortalCreated2.default)({
        userCreated: userCreated,
        hubId: hubId
      });
    } else {
      LOG.warn('No hub id to track portal created from flow: ' + _AppConfigContainer2.default.get('baseHistoryPath'), { extra: { action: action, createInfo: createInfo } });
    }
  } else {
    //this should be coming only from checkout && growth-hub flow
    if (!_isFunnel2.default.growthHub() && !_isFunnel2.default.checkout()) {
      LOG.warn('User only creation action called from flow: ' + _AppConfigContainer2.default.get('baseHistoryPath'));
    }
    //track only signupDone (newUser = true, newPortal = false)
    dispatch((0, _AnalyticsActions.trackSignupDone)({ newUser: userCreated, newPortal: false }));
  }
});
module.exports = exports['default'];